export enum ErrorType {

    UnknownError            = 0,
    FieldRequired           = 1,
    FieldIncorrectValue     = 2,


}